<template>
  <div
    class="lp-child-base"
    :class="hideAddvertise ? `lp-child-base--validCpno` : 'lp-child-base--invalidCpno'"
    :style="styles"
  >
    <block-hero :target-info="targetInfo" :color-scheme="colorScheme" :subsc-url="subscUrl" :lp-id="lpId" />

    <block-chronology :color-scheme="colorScheme" :lp-id="lpId" :subscription-status="subscriptionStatus" :subsc-url="subscUrl" />

    <block-about-fortune2 :color-scheme="colorScheme" :lp-id="lpId" />

    <block-lucky-day :color-scheme="colorScheme" :subsc-url="subscUrl" :lp-id="lpId" />

    <template v-if="!hideAddvertise">
      <!-- <line-campaign-message :target-info="targetInfo" :color-scheme="colorScheme"/> -->
      <!--
      <block-banner
        class="block-banner--middle"
        v-if="showBanner"
        banner-pos="middle"
        :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
        :lp-id="lpId"
        :campaign="'LINE'"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :has-caption="true"
      />
      -->
      <block-uranai-tv-desc-2
        :lp-id="lpId"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        @link="clickLink"
      />
    </template>

    <block-about-counselor
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :lp-id="lpId"
    />

    <!--
    <block-banner
      v-if="showBanner"
      banner-pos="bottom"
      :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
      :lp-id="lpId"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :campaign="'LINE'"
    />
    -->
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
// import BlockReview from '@/utvStore/components/recommend/lp/blocks/BlockReview'
// import BlockReview2 from './blocks/BlockReview2'
// import BlockMenus from '@/utvStore/components/recommend/lp/blocks/BlockMenus'
// import BlockUranaiTv from '@/utvStore/components/recommend/lp/blocks/BlockUranaiTv'
import BlockHero from './blocks/BlockHero'
// import BlockDescriptions from './blocks/BlockDescriptions'
import BlockAboutCounselor from './blocks/BlockAboutCounselor'
// import BlockAboutFortune from './blocks/BlockAboutFortune'
import BlockAboutFortune2 from './blocks/BlockAboutFortune2'
// import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
// import LineCampaignMessage from '@/utvStore/components/recommend/lp/partials/LineCampaignMessage'
// import GoUranaiTv from '@/utvStore/components/recommend/lp/partials/GoUranaiTv'
import BlockUranaiTvDesc2 from './blocks/BlockUranaiTvDesc2'
import BlockChronology from './blocks/BlockChronology'
import BlockLuckyDay from './blocks/BlockLuckyDay'

export default {
  name: 'LpMain',
  components: {
    LpBaseButton,
    BlockHero,
    // BlockDescriptions,
    BlockAboutCounselor,
    // BlockAboutFortune,
    BlockAboutFortune2,
    // BlockReview,
    // BlockReview2,
    // BlockMenus,
    // BlockUranaiTv,
    // BlockBanner,
    // LineCampaignMessage,
    // GoUranaiTv,
    BlockUranaiTvDesc2,
    BlockChronology,
    BlockLuckyDay,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    menusTabList: {
      type: Array,
      default(){
        return []
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    reviewList: {
      type: Array,
      default(){
        return []
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    hideAddvertise: {
      type: Boolean,
      default: false,
    },
    bannerType: {
      type: String,
      // default: 'LINE',
      default: null
    },
    salesInvalid: {
      type: Number,
      default: 0,
    },
    subscUrl: String,
    subscriptionStatus: [ Number, null ],
  },
  computed:{
    reviewListMod() {
      console.log('targetInfo:%O', this.targetInfo)
      return !!this.reviewList && this.reviewList.length > 0 ? this.reviewList : (!!this.targetInfo.reviews ? this.targetInfo.reviews : [])
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    showBanner() {
      return true
    },
  },
  methods: {
    clickLink (payload) {
      // console.log('clickLink:', payload)
      window.gtag('event', 'click', payload.param)
      // let href = payload.link
      // if (href === 'subsc') { href = this.subscUrl }
      // if (href) { location.href = this.$handoverParams(href) }
      location.href = this.$handoverParams(this.subscUrl)
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.btn-base {
  width: 100%;
  padding: 20px;
}
.lp-child-base {
  color: #32373f;
  &--validCpno {}
  &--invalidCpno {}
  .block-uranaitv-base {
    background: #f5f5f5;
    padding-top: 36px;
  }
  /deep/ {
    .baseButton {
      width: 72%;
      max-width: 340px;
      margin: auto;
      min-width: 270px;
    }
    .baseButton__button {
      font-size: 18px;
      font-weight: 600;
      line-height: 1.06;
      padding: 18px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kanoucoco/LpMain.vue